import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import af from "./locales/af.json";
import zu from "./locales/zu.json";
import xh from "./locales/xh.json";
import sn from "./locales/sn.json";
import nd from "./locales/nd.json";
import tn from "./locales/tn.json";
import pt from "./locales/pt.json";
import st from "./locales/st.json";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English", flag: "🇬🇧" },
  { code: "af", label: "Afrikaans", native: "Afrikaans", flag: "🇿🇦" },
  { code: "zu", label: "isiZulu", native: "isiZulu", flag: "🇿🇦" },
  { code: "xh", label: "isiXhosa", native: "isiXhosa", flag: "🇿🇦" },
  { code: "tn", label: "Setswana", native: "Setswana", flag: "🇧🇼" },
  { code: "nd", label: "Ndebele", native: "isiNdebele", flag: "🇿🇼" },
  { code: "sn", label: "Shona", native: "chiShona", flag: "🇿🇼" },
  { code: "st", label: "Sesotho", native: "Sesotho", flag: "🇱🇸" },
  { code: "pt", label: "Portuguese", native: "Português", flag: "🇵🇹" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      af: { translation: af },
      zu: { translation: zu },
      xh: { translation: xh },
      sn: { translation: sn },
      nd: { translation: nd },
      tn: { translation: tn },
      st: { translation: st },
      pt: { translation: pt },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "af", "zu", "xh", "sn", "nd", "tn", "st", "pt"],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "mv_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
